// Locale files for the `home` messages, loaded at build time and keyed by locale.
// Adding a locale is dropping a `<locale>.json` in beside the others — no code change.
const localeModules = import.meta.glob("./home/*.json", { eager: true });

const messages = {};
for (const path in localeModules) {
  const locale = path.match(/\.\/home\/(.+)\.json$/)?.[1];
  if (locale) {
    messages[locale] = localeModules[path].default || localeModules[path];
  }
}

export default messages;
